// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2aEUi","productName":"Table_productName__vU01z"};